// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/tdg-tour-item-schema',
  type: 'object',
  required: ['orderId', 'companyId'],
  nullable: true,
  properties: {
    orderId: {
      type: 'integer',
    },
    companyId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
